import { useGetCustomerMutationReports } from 'api-hooks/report';
import { NavigationRoutes } from 'common/constants';
import useDefaultValuesReportDate from 'hooks/use-default-values-report-date';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { NavigationProps } from 'types';

import PivotReportTemplate from './components/pivot-report-template';

export type CustomerMutationReportParams = {
  filter: {
    customer: string;
  };
};

export default function CustomerMutationReport(
  props: NavigationProps<NavigationRoutes.CustomerMutationReport>,
) {
  const { t } = useTranslation();
  const { query } = useRouter();
  const defaultFilters = useDefaultValuesReportDate('transaction');

  return (
    <PivotReportTemplate
      title={t('common:customer_mutation_report')}
      usePivotQuery={useGetCustomerMutationReports}
      defaultFilters={[
        { name: 'customer', value: query['filter[customer]'] as string },
        ...defaultFilters,
      ]}
      isShowAllFilterCompleted
    />
  );
}
